export default "__VITE_ASSET__DUoETIcS__"